<template>
  <layout :session="session">
    <div class="mt-12 sm:mt-0 px-4 py-5 text-center">
      <div class="min-w-0 flex-1 h-full max-w-sm mx-auto lg:order-last px-3 select-none flex items-center">

        <Link :href="backLink">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-7 h-7 hover:text-markencode-blue mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
        </Link>

        <img src="/img/participate.png" class="w-3/5 sm:w-4/5 mx-auto my-12" />
      </div>

      <div class="mt-12 sm:mt-12 flex items-center justify-center w-full">
        <div v-html="session.anonymous_access_link_qrcode" class="w-3/5 sm:w-64"></div>


      </div>

      <div class="text-left px-5 mx-auto max-w-lg"
      :class="session.session_type == 'productivity' ? 'mt-8' : 'mt-16'">

        <p v-if="session.session_type == 'productivity'" class="font-extralight whitespace-pre-line mb-5">5 Fragen zur schnellen intuitiven Produktivitätsmessung in Anlehnung an John Strelecky</p>

        <div class="border-t border-gray-400 mb-4"></div>

        <p v-if="session.introtext" class="font-extralight whitespace-pre-line" v-html="session.introtext"></p>

        <div v-if="session.session_type != 'productivity'">

          <p v-if="!session.activated_at && !session.testmode" class="mt-10 text-sm text-markencode-red">Dieser Workshop kann nicht
            durchgeführt werden, weil er noch nicht gestartet wurde.</p>

          <p v-else-if="session.completed_at" class="mt-10 text-sm text-markencode-red">Dieser Workshop kann nicht
            durchgeführt werden, weil er bereits abgeschlossen ist.</p>

          <p v-else-if="!session.can_be_activated" class="mt-10 text-sm text-markencode-red">Dieser Workshop kann nicht
            gestartet werden, weil noch nicht alle Pflichtangaben ausgefüllt worden sind.</p>
        </div>

        <p class="mt-5 font-extralight">
          Bitte teilen Sie diesen Code mit anderen.
        </p>

        <div class="flex items-center justify-between mx-auto mt-6 w-3/12 sm:w-2/12 gap-x-3 sm:gap-x-0">

          <a :href="route('control-panel.workshops.qrcode.download', { sessionUuid: session.uuid })">
            <svg v-tooltip.top="`Download QR-Code`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke-width="1.5" stroke="currentColor"
              class="w-6 h-6 text-gray-700 hover:text-markencode-blue cursor-pointer outline-none">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
          </a>


          <svg v-tooltip.top="`Link in Zwischenablage kopieren`" @click="copyLink" xmlns="http://www.w3.org/2000/svg"
            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-6 h-6 hover:text-markencode-blue cursor-pointer outline-none" :class="copyClasses">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
          </svg>
        </div>



      </div>



    </div>



    <template v-slot:footer>
      <a v-if="canBeStarted" :href="route('control-panel.phase', {
        sessionUuid: session.uuid,
        phaseId: 1,
      })
        "
        class="inline-flex justify-center w-full sm:w-min rounded-none sm:rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 bg-brandpreneurship-dark-gray text-base leading-6 font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50">WEITER</a>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';

export default {
  components: {
    Layout,
  },

  props: ['session', 'translations'],


  data() {
    return {
      copySuccess: null,
    };
  },

  methods: {
    copyLink: function () {
      this.$copyText(String(this.session.anonymous_access_link)).then((e) => {
        this.copySuccess = true;
        // console.log(e)

        setTimeout(() => this.copySuccess = null, 3000);
      }, (e) => {
        this.copySuccess = false;
        // console.log(e)

        setTimeout(() => this.copySuccess = null, 3000);
      })
    },
  },

  computed: {
    copyClasses() {
      if (this.copySuccess === false) {
        return 'text-markencode-red animate-pulse';
      }

      if (this.copySuccess) {
        return 'text-markencode-green animate-pulse';
      }

      return 'text-gray-700 animate-none';
    },

    canBeStarted() {
      if (this.session.testmode) {
        return true;
      }

      if (this.session.session_type == 'productivity') {
        return true;
      }

      if (this.session.can_be_activated && !this.session.completed_at && this.session.activated_at) {
        return true;
      }

      return false;
    },

    backLink() {
      return this.session.session_type == 'productivity' ? this.route('control-panel.index') : this.route('control-panel.workshops.index');
    },  
  },
};
</script>